import { BusinessVerifier } from '@models/business/BusinessVerifier'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { BUSINESS_VERIFIERS_URL } from '../../utils/urls'

const fetchBusinessVerifiers = (params: TableParams) =>
  SBAPI.FetchPaginated<BusinessVerifier[]>(BUSINESS_VERIFIERS_URL, params)

const fetchBusinessVerifierById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<BusinessVerifier>(`${BUSINESS_VERIFIERS_URL}/${id}`, params)

const createBusinessVerifier = (BusinessVerifier: BusinessVerifier) =>
  SBAPI.Post(BUSINESS_VERIFIERS_URL, BusinessVerifier)

const updateBusinessVerifier = (BusinessVerifier: BusinessVerifier) =>
  SBAPI.Put(
    `${BUSINESS_VERIFIERS_URL}/${BusinessVerifier.id}`,
    BusinessVerifier
  )

const deleteBusinessVerifier = (BusinessVerifier: BusinessVerifier) =>
  SBAPI.Delete(`${BUSINESS_VERIFIERS_URL}/${BusinessVerifier.id}`)

export {
  createBusinessVerifier,
  deleteBusinessVerifier,
  fetchBusinessVerifierById,
  fetchBusinessVerifiers,
  updateBusinessVerifier,
}
